import { Component, OnInit } from '@angular/core';
import { AppTitleService } from '@services/title.service';

import { TokenService } from '@services/token.service';
import { AuthService } from 'src/app/auth/services/auth.service';

@Component({
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css'],
})
export class HomeComponent implements OnInit {
    remaining_time;
    timer;
    constructor(
        private apiAuth: AuthService,
        private tokenService: TokenService,
        private titleService: AppTitleService
    ) {}

    ngOnInit() {
        this.handleStart();
        this.titleService.setTitle('Portal');
    }

    logoutUser() {
        this.apiAuth.logout();
    }

    // timer functions

    async handleStart() {
        const expirationTime = this.tokenService.expirationTime;
        this.remaining_time = expirationTime - new Date().getTime();

        this.timer = setInterval(async () => {
            this.remaining_time = this.remaining_time - 1000;
            if (this.remaining_time <= 60000) {
                this.handleStop();
                this.apiAuth.refresh_token().subscribe(
                    res => {
                        this.handleRestart();
                    },
                    err => {
                        console.log(err);
                        alert(err['error']['non_field_error']);
                        this.handleFullStop();
                    }
                );
            }
        }, 1000);
    }

    handleStop() {
        if (this.timer) {
            clearInterval(this.timer);
        }
    }

    handleFullStop() {
        this.handleStop();
        this.apiAuth.logout();
    }

    async handleRestart() {
        this.handleStop();
        await this.handleStart();
    }
}
